module.exports = __webpack_public_path__ + "static/roca-361ef5273c8ea4ba5af10bacdacb96b7.woff";